
import { VueSlickPopover, VueSlickPopoverContent } from 'vue-slick-popover'
import 'vue-slick-popover/dist/vue-slick-popover.css'

export default {
  components: {
    VueSlickPopover,
    VueSlickPopoverContent,
  },
  props: {
    pinSelectedId: {
      type: String,
      default: '',
    },
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isPopoverVisible: false,
      popoverOptions: {
        animation: 'scale-fade',
        popoverReference: null,
        placement: null,
        offset: '0,30',
      },
    }
  },
  watch: {
    pinSelectedId: {
      handler(val) {
        if (val !== this.blok._uid) {
          this.closePopover()
        }
      },
    },
  },

  mounted() {
    this.popoverOptions.popoverReference = this.$refs.popoverReference
    this.$nextTick(() => {
      this.popoverOptions.placement = this.blok.placement || 'right-start'
    })
  },

  methods: {
    closePopover() {
      this.isPopoverVisible = false
    },

    openPopover() {
      this.$emit('setId', this.blok._uid)
      this.isPopoverVisible = true
    },
  },
}
